import { newDiv, createImage, prepareEvent } from '../RenderUtils';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';
import { checkIsValidCurrentValue, checkIsValidVariants } from './checkIsValid';

const getFloorTitle = (name) => {
  const words = name.split(' ');
  return words[words.length - 1];
};

export class FloorControl {
  static isConfigurationValid = ({ current, variants }) => {
    const isValidCurrentValue = checkIsValidCurrentValue({
      current,
      expectedVariants: variants,
      name: 'floor',
    });
    const isValidVariants = checkIsValidVariants({ variants, name: 'floor' });

    return isValidCurrentValue && isValidVariants;
  };

  constructor(container, controlSetup, parentIframe) {
    this.container = container;
    this.controlSetup = controlSetup;
    this.parentIframe = parentIframe;
  }

  render() {
    const container = newDiv(null, this.container);

    const classContainer = 'FloorControl';
    const classContent = 'FloorControl-options';

    const contentContainer = document.createElement('div');

    contentContainer.classList.add(classContent);
    container.appendChild(contentContainer);
    container.classList.add(classContainer);

    this.controlSetup.element = container;

    const activateOption = (value, element) => {
      if (value === this.controlSetup.current) return;

      this.controlSetup.current = value;
      this.controlSetup.currentElement.classList.remove('-active');
      this.controlSetup.currentElement = element;
      this.controlSetup.currentElement.classList.add('-active');

      this.parentIframe.postMessage(
        {
          type: 'buttons',
          action: 'option',
          name: this.controlSetup.name,
          value,
        },
        '*',
      );
    };

    container.style.height = `${64 + this.controlSetup.variants.length * 32}px`;

    for (let j = 0; j < this.controlSetup.variants.length; j += 1) {
      const value = this.controlSetup.variants[j];
      const optionContent = value && typeof value === 'string' ? getFloorTitle(value) : j + 1;

      const option = newDiv(optionContent, contentContainer, {
        append: 'begin',
      });
      option.classList.add('Option');
      addAnalyticsAttribute(option, CONTROLS_EVENTS_GA.FLOOR_ITEM);

      if (value === this.controlSetup.current) {
        option.classList.add('-active');
        this.controlSetup.currentElement = option;
      }

      option.addEventListener(
        'click',
        (e) => {
          prepareEvent(e);
          activateOption(value, option);
        },
        false,
      );

      this.controlSetup.variants[j] = {
        value,
        element: option,
        activate: activateOption,
      };
    }

    this.renderArrowUp();
    this.renderArrowDown();
  }

  updateFloor(diff) {
    const currentValue = this.controlSetup.current;
    const currentIndex = this.controlSetup.variants.findIndex((v) => v.value === currentValue);
    const nextIndex = currentIndex + diff;
    const countFloors = this.controlSetup.variants.length;

    if (nextIndex >= countFloors || nextIndex < 0) {
      return;
    }

    const nextVariant = this.controlSetup.variants[nextIndex];

    this.controlSetup.currentElement.classList.remove('-active');

    this.controlSetup.current = nextVariant.value;
    this.controlSetup.currentElement = nextVariant.element;
    this.controlSetup.currentElement.classList.add('-active');

    this.controlSetup.currentElement.scrollIntoView({
      block: 'nearest',
    });

    this.parentIframe.postMessage(
      {
        type: 'buttons',
        action: 'option',
        name: this.controlSetup.name,
        value: nextVariant.value,
      },
      '*',
    );
  }

  renderArrowUp() {
    const arrowUp = newDiv(createImage('/images/map/arrow_up.svg'), this.controlSetup.element, {
      append: 'begin',
    });
    arrowUp.classList.add('FloorControl-arrow');
    addAnalyticsAttribute(arrowUp, CONTROLS_EVENTS_GA.FLOOR_ARROW_UP);

    arrowUp.addEventListener(
      'click',
      (e) => {
        prepareEvent(e);
        this.updateFloor(1);
      },
      false,
    );
  }

  renderArrowDown() {
    const arrowDown = newDiv(createImage('/images/map/arrow_down.svg'), this.controlSetup.element);
    arrowDown.classList.add('FloorControl-arrow');
    addAnalyticsAttribute(arrowDown, CONTROLS_EVENTS_GA.FLOOR_ARROW_DOWN);

    arrowDown.addEventListener(
      'click',
      (e) => {
        prepareEvent(e);
        this.updateFloor(-1);
      },
      false,
    );
  }
}
